import { z } from "zod";

/**
 * URL search params for the money audit (PAYD-FR-138, rule S3).
 *
 * All three live in the URL so a finding is a link somebody can send: "here
 * is the recovery I am asking about" beats "open the audit, pick Priya, set
 * March to June". `membership` is an opaque id, never a name or an email, so
 * nothing personal reaches browser history or an access log (FE-SEC7).
 */
export const moneyAuditRouteSearchSchema = z
  .object({
    membership: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
  })
  .strict();

export type MoneyAuditRouteSearch = z.infer<typeof moneyAuditRouteSearchSchema>;
